import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

const USER_CONFIG_MODAL_NAME = 'UserConfigModal'

const UserConfigFormModal = Loadable(() => import('./UserConfigForm'))

export const createUserConfigNavigationItem = createNavigationConfig((translateFn: (key: string) => string) => ({
  icon: 'config',
  text: translateFn('mnu_file_user_conf'),
  identity: USER_CONFIG_MODAL_NAME,
  component: UserConfigFormModal,
}))
